import {Fragment} from "react";
import {Box} from "@mui/system";
import _ from "lodash";
import styles from "./conversationStyles";
import EmailInfoItem from "./EmailInfoItem";
import {
    getFullName,
    getMessageDirection,
    isUserMessage,
    shouldShowCopyIcon
} from "../../../utilities/ConversationUtils";
import {stripNumbersFromUsername} from "_helpers";
import {supportedSourcesToShowMoreAuthorDetails} from "_constants";

export default function AuthorInfo({ conversationItem, message }) {
    let {authorName, authorEmail, isTrendsSource, alternativePhoneNumbers, alternativeEmails, phoneNumber} = conversationItem;
    const sourceName = _.toString(_.get(message, 'sourceName')).toLowerCase();
    const isEmail = !isTrendsSource;
    const direction = getMessageDirection(conversationItem, message);
    const withCopyAction = shouldShowCopyIcon(direction);
    const tooltipLabel = 'Copy name';
    const toastLabel = 'Copied name to clipboard';
    const showMoreAuthorDetails = supportedSourcesToShowMoreAuthorDetails.includes(sourceName);
    const excludeAuthorId = !showMoreAuthorDetails;
    authorName = stripNumbersFromUsername(authorName);
    const fullName = getFullName(message, conversationItem);
    const showAlternativeContact = !_.isEmpty(alternativePhoneNumbers) && !_.isEmpty(alternativeEmails) && isUserMessage(message, conversationItem);

    const AlternativeContacts = ({contactList, actionName}) => {
        contactList = contactList || [];
        if(contactList.length === 0) {
            return <Fragment />;
        }

        return contactList.map(contact => {
            return(
                <Box sx={{my: '3px'}}>
                    <EmailInfoItem
                        label={`${contact}`}
                        copyText={contact}
                        tooltipLabel={actionName}
                        withCopyAction={withCopyAction}
                    />
                </Box>
            )
        })
    }

    return(
        <Fragment>
            {
                isEmail ?
                    <Box sx={{display: 'flex',}}>
                        {
                            excludeAuthorId &&
                            <Box sx={{marginRight: '5px'}}>
                                <EmailInfoItem
                                    label={
                                        <Fragment>From:<Box sx={styles.fromName} component={'span'}> {authorName} </Box></Fragment>
                                    }
                                    copyText={authorName}
                                    withCopyAction={withCopyAction}
                                    tooltipLabel={tooltipLabel}
                                    toastLabel={toastLabel}
                                />
                            </Box>
                        }
                        <Box>
                            {
                                authorEmail &&
                                <EmailInfoItem
                                    label={`${excludeAuthorId ? "" : "From:"} <${authorEmail}>`}
                                    copyText={authorEmail}
                                    withCopyAction={withCopyAction}
                                />
                            }
                            {
                                phoneNumber && phoneNumber &&
                                <EmailInfoItem
                                    label={`${phoneNumber}`}
                                    copyText={phoneNumber}
                                    withCopyAction={withCopyAction}
                                    tooltipLabel={'Copy phone number'}
                                />
                            }
                            {
                                showMoreAuthorDetails && fullName &&
                                <EmailInfoItem
                                    label={`${fullName}`}
                                    copyText={fullName}
                                    withCopyAction={withCopyAction}
                                    tooltipLabel={'Copy name'}
                                />
                            }
                            {
                                showMoreAuthorDetails && showAlternativeContact &&
                                <Box sx={{my: '4px'}}>
                                    <Box>Alternative contact:</Box>
                                    <AlternativeContacts contactList={alternativeEmails} actionName={'Copy email'}/>
                                    <AlternativeContacts contactList={alternativePhoneNumbers} actionName={'Copy phone number'}/>
                                </Box>
                            }
                        </Box>

                    </Box>
                    :
                    <EmailInfoItem
                        label={authorName}
                        copyText={authorName}
                        withCopyAction={withCopyAction}
                        tooltipLabel={tooltipLabel}
                        toastLabel={toastLabel}
                    />
            }
        </Fragment>
    )
}